/*
 * @Author: your name
 * @Date: 2021-12-15 15:17:24
 * @LastEditTime: 2021-12-16 19:42:23
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \app-h5\src\locales\en-US.js
 */
// 美国 - 英语
export default {
  mobile: 'Mobile',
  plzInput: 'Please input the',
  payResult: 'Repayment Result',
  plzPhone: 'Please input your phone mobile number!',
  plzGraphicVerification: 'Please input the graphic verification code!',
  plzSms: 'Please input the captcha you got!',
  plzPwd: 'Please input the password!',
  plzComPwd: 'Please input the Confirm password!',
  plzGgree: 'Should accept agreement!',
  wrongPhone: 'Wrong phone number!',
  more4: 'More than 4 length!',
  less4: 'Less than 4 length!',
  smsNoClick: 'SMS sent, Non clickable!',
  smsSendSuccess: 'Sent successfully',
  graphicCode: 'Graphic Code',
  registerSuccess: 'Register successfully',
  wrongInvite: 'Wrong invite code!',
  needDownload: 'You need download the app to <br/>get your money.',
  plzVerification: 'Please enter verification code',
  plzSetPwd: 'Please set your password',
  comPwd: 'Confirm password',
  pwd: 'password',
  inviteCode: 'Invitation Code (optional)',
  accept: 'I accept these',
  termsOfUse: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  and: 'and',
  registerNow: 'Register Now',
  notMatch2Pwd: 'The two passwords that you entered do not match!',
  downloadNow: 'Download Now',
  send: 'Send',
  resend: 'Resend',
  sending: 'Sending',

  // 预授信
  approvalTitle: 'Application Result',
  approvalNoted: 'Note',
  approvalWaiting: 'Application Reviewing',
  approvalWaitingNote: 'We have received your application. Please wait a few minutes for the application result. Now we are analyzing your credit profile and we will inform you of the results through the app and SMS.',
  approvalFailed: 'Apply again in 24 hours',
  approvalFailedNote: `We regret to inform you that we are currently unable to provide you with the requested loan. The reason is that we cannot get enough information from your credit file. We sincerely invite you to apply for a loan in the future.`,
  approvalSuccess: 'Disbursement Processing',
  approvalSuccessNote: `Your loan application has been approved. It will take 2 to 24 hours in disbursement depending on the bank.`,
  soonJumpHome: 'Apply for a loan, About to return to the home page!',
  ok: 'OK',
  openingApp: 'Opening app, content copied.',
  plzCheckUid: 'Please Check the link is complete',
  inviteFriends: 'Invite friends',
  cancel: 'Cancel',
  pageLoading: 'Page loading, please wait...',

  repaymentProcessing: 'Repayment Processing',
  repayment: 'repayment',
  aceptado: 'aceptado',
  waitResponse: 'please wait a few minutes for the response',
  copySuccess: 'Copy successful',
  copiedAndSend: 'Invitation link copied, please open SMS/Email/Messenger and send it',
  waitLucky: 'Lucky drawing, please wait a second',

  tifiApprovalWaiting: 'Application processing',
  tifiApprovalWaitingNote: 'We have received your application. We are analyzing your credit profile and informing you of the results through apps and SMS.',

  tifiApprovalFailed: 'Failed to request audit again after 24 hours',
  tifisliceApprovalFailed: 'Failed to request audit, apply again after 24 hours',
  tifiApprovalFailedNote: "Oh dear. We regret to inform you that ipeso is currently unable to provide you with the requested loan. The reason is that we can't. Get enough information from your credit file.. We sincerely invite you to apply for a loan in the future.",

  tifiApplySuccessTitle: 'Bank loan',
  tifiApplySuccessNote: 'Your application is already approved and we are working on the deposit. You will receive 1 cent to your account indicated for verification. It will take between 2 and 24 hours depending on your bank.',
}